import { CityTitle } from '../constants/localization/cities'
import Countries from '../constants/localization/countries'
import i18n from '../locales/i18n'
import { CountryCode } from '../types'
import { findById } from './index'

export const getAvailableCountry = (country?: CountryCode) => {
  if (!country) {
    return 'US'
  }

  return findById(country, Countries) ? country : 'US'
}

export const createStatesMap = (states: { [x: string]: string }) =>
  Object.entries(states).map(([id, name]) => ({ id, name }))

export const getCityTitle = (country: CountryCode) =>
  CityTitle[country] ?? i18n.t('Regions:TERRITORY.CITY')
